// extracted by mini-css-extract-plugin
export default {"loader":"AccordionLoader_loader__W0k-r","rot":"AccordionLoader_rot__z8y81","loader_text":"AccordionLoader_loader_text__0RI75"};